export const RESERVED_VARIABLES = new Set(['customer', 'user_group', 'properties']);
